<form [formGroup]="form" class="events-filter">
  <header
    class="events-filter__header"
    role="button"
    tabindex="0"
    [attr.aria-expanded]="isExpanded()"
    aria-controls="eventsFilterContent"
    (click)="toggleExpanded()"
    (keydown.enter)="toggleExpanded()"
    (keydown.space)="toggleExpanded()">
    <div class="events-filter__heading">
      <i class="pi pi-filter events-filter__heading-icon"></i>
      <div>
        <h3 class="events-filter__title">Filtrar eventos</h3>
        <p class="events-filter__subtitle">Encontre eventos por nome, categoria, cidade ou período.</p>
      </div>
    </div>

    <div class="events-filter__header-actions">
      @if (hasActiveFilters()) {
        <span class="events-filter__active-badge">
          <i class="pi pi-check-circle"></i>
          {{ activeFiltersCount() }} filtro{{ activeFiltersCount() > 1 ? "s" : "" }} ativo{{
            activeFiltersCount() > 1 ? "s" : ""
          }}
        </span>
      }

      <i
        class="pi events-filter__chevron"
        [class.pi-chevron-down]="!isExpanded()"
        [class.pi-chevron-up]="isExpanded()"></i>
    </div>
  </header>

  @if (isExpanded()) {
    <div
      id="eventsFilterContent"
      class="events-filter__row"
      animate.enter="events-filter__row--enter"
      animate.leave="events-filter__row--leave">
      <div class="events-filter__field events-filter__field--query">
        <label for="filterQuery" class="events-filter__label">
          <i class="pi pi-search"></i>
          Buscar evento
        </label>
        <input
          id="filterQuery"
          type="text"
          class="form-control events-filter__input"
          formControlName="query"
          placeholder="Ex: Festival de Verão 2026" />
      </div>

      <div class="events-filter__field">
        <label for="filterCategory" class="events-filter__label">
          <i class="pi pi-tag"></i>
          Categoria
        </label>
        <p-select
          id="filterCategory"
          formControlName="categoryId"
          styleClass="w-100 events-filter__select"
          [options]="categoryOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Todas as categorias"
          emptyMessage="Nenhuma categoria encontrada"
          [showClear]="true"
          [filter]="true"
          filterBy="label" />
      </div>

      <div class="events-filter__field">
        <label for="filterCity" class="events-filter__label">
          <i class="pi pi-map-marker"></i>
          Cidade
        </label>
        <p-select
          id="filterCity"
          formControlName="city"
          styleClass="w-100 events-filter__select"
          [options]="cityOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Todas as cidades"
          emptyMessage="Nenhuma cidade encontrada"
          [showClear]="true"
          [filter]="true"
          filterBy="label" />
      </div>

      <div class="events-filter__field">
        <label for="filterDateRange" class="events-filter__label">
          <i class="pi pi-calendar"></i>
          Período
        </label>
        <p-datePicker
          id="filterDateRange"
          formControlName="dateRange"
          selectionMode="range"
          dateFormat="dd/mm/yy"
          inputStyleClass="w-100 events-filter__datepicker-input"
          [showIcon]="true"
          [iconDisplay]="'input'"
          [readonlyInput]="true"
          placeholder="Selecione as datas" />
      </div>

      <div class="events-filter__actions">
        <app-button
          styleType="outlined"
          icon="pi pi-times"
          [disabled]="!hasActiveFilters()"
          (btnClick)="clearFilters()">
          Limpar
        </app-button>
      </div>
    </div>
  }
</form>
